import React, { useEffect, useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';

import { IngresoQCScreen } from './Tabs/IngresoQCScreen';
import { InventarioQCScreen } from './Tabs/InventarioQCScreen';
import { SalidasCocinasScreen } from './Tabs/SalidasCocinasScreen';

import Card from '../../../../Base/Components/Card/Card';
import CalendarWeek from '../../../../Base/Components/Form/CalendarWeek';
import { setTitlePage } from '../../../../Base/Services/Config/ConfigService';
import { getDateProduccionSQL } from '../../../../Base/Services/FechasService';

import { getIngresosQC, getIngresosQCPlantaTratamiento, getInventarioPlantaTratamiento, getInventarioQC, getSalidasCocina, getSalidasPlantaTratamiento } from '../../../../API/Produccion/QuimicosColorantes/ControlQCRequests';



export const ControlQCScreen = ({ plantaTratamiento }) => {


    const [date, setDate] = useState([new Date(), new Date()]);
    const [loading, setLoading] = useState(false);

    const [ingresosQC, setIngresosQC] = useState([]);
    const [salidasQC, setSalidasQC] = useState([]);
    const [inventarioQC, setInventarioQC] = useState([]);

    const getInfo = async () => {
        setLoading(true);
        if (date) {
            const fechas = getDateProduccionSQL(date);
            if (plantaTratamiento) {
                const i = await getIngresosQCPlantaTratamiento({ Fecha1: fechas[0], Fecha2: fechas[1] });
                setIngresosQC(i);
                const s = await getSalidasPlantaTratamiento({ Fecha1: fechas[0], Fecha2: fechas[1] });
                setSalidasQC(s);
                const t = await getInventarioPlantaTratamiento();
                setInventarioQC(t);
            } else {
                const i = await getIngresosQC({ Fecha1: fechas[0], Fecha2: fechas[1] });
                setIngresosQC(i);
                const s = await getSalidasCocina({ Fecha1: fechas[0], Fecha2: fechas[1] });
                setSalidasQC(s);
                const t = await getInventarioQC();
                setInventarioQC(t);
            }
        }
        setLoading(false);
    }

    useEffect(() => {
        setTitlePage(plantaTratamiento? 'Control Q/C Planta Tratamiento': 'Control Q/C Cocina');
        getInfo();
    }, [plantaTratamiento])

    return (
        <Card
            titulo={<div className='botones'>
                <h3 className='title-card'>{plantaTratamiento? 'Control Q/C Planta Tratamiento': 'Control Q/C Cocina'}</h3>
                <CalendarWeek
                    date={date}
                    setDate={setDate}
                    selectionMode='range'
                    buscar={getInfo}
                    loading={loading}
                    showButton={true}
                />
            </div>}
            contenido={
                <div className='pt-4'>
                    <TabView style={{}}>
                        <TabPanel header={plantaTratamiento? 'Ingresos': 'Ingresos Almacén'} >
                            <IngresoQCScreen ingresosQC={ingresosQC} loading={loading} plantaTratamiento={plantaTratamiento} />
                        </TabPanel>

                        { plantaTratamiento && <TabPanel header='Inventario'>
                            <InventarioQCScreen inventarioQC={inventarioQC} loading={loading} />
                        </TabPanel>}

                        <TabPanel header={plantaTratamiento? 'Salidas' :'Salidas Cocina'}>
                            <SalidasCocinasScreen salidasQC={salidasQC} loading={loading} plantaTratamiento={plantaTratamiento} />
                        </TabPanel>
                    </TabView>
                </div>
            }
        />
    )
}

export default ControlQCScreen